import { CircularProgress } from '@mui/material'
import React from 'react'

function LoadingState() {
  return (
      <div className='flex justify-center h-full align-middle items-center w-full'>
        <CircularProgress color="success"/>
      </div>
  )
}

export default LoadingState